import { createFileRoute } from "@tanstack/react-router";

import { StaticPage } from "@/components/site-footer";
import { loadSiteContent, useSiteContent } from "@/lib/content";
import { pageCrumbs, pageMeta, pageTitle } from "@/lib/seo";

import { publicPageHeaders } from "./-public-cache";

export const Route = createFileRoute("/guide")({
  // already in the cache from the root route; here for the page's title and description
  loader: ({ context }) => loadSiteContent(context.queryClient),
  head: ({ loaderData }) => {
    const title = loaderData?.guidePage.title ?? "راهنمای خرید";
    return {
      meta: [
        ...pageMeta(pageTitle(title), loaderData?.guidePage.metaDescription),
        pageCrumbs(title, "/guide"),
      ],
    };
  },
  headers: publicPageHeaders,
  component: GuidePage,
});

function GuidePage() {
  return <StaticPage page={useSiteContent().guidePage} />;
}
